import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import { TEMPLATE_PATH } from '../api'
import { SmsTemplateCreateInterface, SmsTemplateUpdateInterface } from '../types'

export const useSmsTemplateActions = () => {
  const { fetcher } = useFetch<
    RequestMethodsEnum.post,
    SmsTemplateUpdateInterface,
    SmsTemplateCreateInterface
  >({ method: RequestMethodsEnum.post })

  const { fetcher: updateFetcher } = useFetch<
    RequestMethodsEnum.put,
    SmsTemplateUpdateInterface,
    SmsTemplateUpdateInterface
  >({ method: RequestMethodsEnum.put })

  const { fetcher: deleteFetcher } = useFetch<RequestMethodsEnum.delete>({
    method: RequestMethodsEnum.delete,
  })

  const { fetcher: duplicateFetcher } = useFetch<
    RequestMethodsEnum.post,
    SmsTemplateUpdateInterface
  >({
    method: RequestMethodsEnum.post,
  })

  return {
    createSmsTemplate: (template: SmsTemplateCreateInterface) => fetcher(TEMPLATE_PATH, template),
    updateSmsTemplate: (template: SmsTemplateUpdateInterface) =>
      updateFetcher(TEMPLATE_PATH, template),
    deleteSmsTemplate: (id: SmsTemplateUpdateInterface['id']) =>
      deleteFetcher(TEMPLATE_PATH + '/' + id),
    duplicateSmsTemplate: (id: SmsTemplateUpdateInterface['id']) =>
      duplicateFetcher(TEMPLATE_PATH + '/duplicate/' + id),
  }
}
